import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
    loading: boolean;
    error: string | null;
    refreshToken: string | null;
    accessToken: string | null;
    message: string | null;
}

const initialState: AuthState = {
    loading: false,
    error: null,
    refreshToken: null,
    accessToken: null,
    message: null,
};

const guestAuthSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        // No payload needed since no body is sent
        fetchTokenRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchTokenSuccess: (
            state,
            action: PayloadAction<{ accessToken: string; refreshToken: string; message: string }>,
        ) => {
            state.loading = false;
            state.accessToken = action.payload.accessToken;
            state.refreshToken = action.payload.refreshToken;
            state.message = action.payload.message;
        },
        fetchTokenFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        // Iframe token management actions
        setIframeToken: (state, action: PayloadAction<{ accessToken: string }>) => {
            // Only update if token is different to prevent unnecessary re-renders
            if (state.accessToken !== action.payload.accessToken) {
                state.accessToken = action.payload.accessToken;
                state.error = null;
                state.loading = false;
            }
        },
        refreshIframeToken: (state, action: PayloadAction<{ accessToken: string }>) => {
            // Only update if token is different to prevent unnecessary re-renders
            if (state.accessToken !== action.payload.accessToken) {
                state.accessToken = action.payload.accessToken;
                state.error = null;
                state.loading = false;
            }
        },
        clearIframeToken: (state) => {
            state.accessToken = null;
            state.refreshToken = null;
            state.error = null;
            state.loading = false;
            state.message = null;
        },
    },
});

export const {
    fetchTokenRequest,
    fetchTokenSuccess,
    fetchTokenFailure,
    setIframeToken,
    refreshIframeToken,
    clearIframeToken,
} = guestAuthSlice.actions;
export const guestReducer = guestAuthSlice.reducer;
